var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.000977 0h20v20h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.16797 5.83333-1.16667 1.16667 2.1667 2.16667h-8.50003v1.66663h8.50003l-2.1667 2.1667 1.16667 1.1667 4.16663-4.1667zm7.50003 9.99997h-6.6667v1.6667h6.6667c.9166 0 1.6666-.75 1.6666-1.6667v-11.66663c0-.91667-.75-1.66667-1.6666-1.66667h-6.6667v1.66667h6.6667z",
    fill: "#f45197"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle1);
export default __webpack_public_path__ + "static/media/user_circle1.c49c12c826d30e4fcecbd28e81a7ed42.svg";
export { ForwardRef as ReactComponent };